// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"77":"1b42e73a","641":"8395534f"}[chunkId] + ".css";
};